/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Setting,
    SettingFromJSON,
    SettingFromJSONTyped,
    SettingToJSON,
} from './';

/**
 * 
 * @export
 * @interface SettingDataFrame
 */
export interface SettingDataFrame {
    /**
     * 
     * @type {number}
     * @memberof SettingDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof SettingDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof SettingDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Setting>}
     * @memberof SettingDataFrame
     */
    data: Array<Setting>;
}

export function SettingDataFrameFromJSON(json: any): SettingDataFrame {
    return SettingDataFrameFromJSONTyped(json, false);
}

export function SettingDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettingDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(SettingFromJSON)),
    };
}

export function SettingDataFrameToJSON(value?: SettingDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(SettingToJSON)),
    };
}


